import * as _ from 'lodash';
import * as types from './types';

import { FieldEnum } from 'Common/FieldEnum';

const INITIAL_STATE = {
  userSetup: {
    Data: [],
    Errors: [],
  },
  showInactive: false,
  filteredData: [],
  result: {
    errors: [],
    isSubmitting: false,
  },
  roles: [],
  isUserGridLoading: false,
  isAssignGridLoading: false,
  assignSiteData: [],
  assignCurrentUser: null,
  initialData: [],
  checkAllChecked: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.USERSETUP_CHECKALL_ASSIGN_SITE_DATA:
      let copiedData = state.assignSiteData.slice();
      const { checkAll } = action.payload;
      copiedData.forEach(x => {
        const foundRow = _.find(action.payload.currentRows, { Id: x.Id });
        if (foundRow) {
          x[FieldEnum.Allowed] !== checkAll &&
            x[FieldEnum.AccessibleFunctions] &&
            x[FieldEnum.AccessibleFunctions].length &&
            _.forEach(x[FieldEnum.AccessibleFunctions], menuAccess => {
              menuAccess[FieldEnum.IsPageAccessible] = checkAll;
            });
          x.Allowed = checkAll;
        }
      });

      return {
        ...state,
        assignSiteData: copiedData,
        checkAllChecked: checkAll,
      };
    case types.USERSETUP_CLEAR_ASSIGN_SITE_DATA:
      return {
        ...state,
        assignSiteData: [],
      };
    case types.USERSETUP_SET_ASSIGN_CURRENT_USER:
      return {
        ...state,
        assignCurrentUser: action.payload,
      };
    case types.USERSETUP_UPDATE_ASSIGN_SITE_DATA: {
      let checkAllChecked = false;
      let newData = state.assignSiteData.slice();
      let item = _.find(newData, { Id: action.payload.Id });
      if (item === undefined) {
        return state;
      }
      item.Allowed = action.payload.Allowed ? 0 : 1;
      item[FieldEnum.AccessibleFunctions] &&
        item[FieldEnum.AccessibleFunctions].length &&
        _.forEach(item[FieldEnum.AccessibleFunctions], menuAccess => {
          menuAccess[FieldEnum.IsPageAccessible] = item[FieldEnum.Allowed];
        });
      checkAllChecked =
        newData.length !== 0 &&
        newData.length === _.sumBy(newData, user => user[FieldEnum.Allowed]);
      return {
        ...state,
        assignSiteData: newData,
        checkAllChecked,
      };
    }

    case types.USERSETUP_SET_ASSIGN_SITE_DATA:
      return {
        ...state,
        assignSiteData: action.payload.data.Data,
        initialData: action.payload.data.Data,
      };
    case types.USERSETUP_SET_ASSIGN_GRIDLOADING:
      return {
        ...state,
        isAssignGridLoading: action.payload,
      };
    case types.USERSETUP_SET_USER_GRIDLOADING:
      return {
        ...state,
        isUserGridLoading: action.payload,
      };

    case types.USERSETUP_CLEAR_ERRORS:
      return {
        ...state,
        result: {
          ...state.result,
          errors: [],
        },
      };
    case types.USERSETUP_GET:
      //filter out the service user
      return {
        ...state,
        userSetup: {
          Errors: action.payload.data.Errors,
          Data: _.filter(action.payload.data.Data, x => x.Id !== 0),
        },
      };
    case types.USERSETUP_GET_ROLES:
      const roles = action.payload.data.Data;
      let orderedRoles = _.orderBy(roles, [
        roles => roles.Description.toLowerCase(),
      ]);
      return { ...state, roles: orderedRoles };
    case types.USERSETUP_ERROR:
      return {
        ...state,
        userSetup: { ...state.userSetup, Errors: action.payload.data.Errors },
      };
    case types.USERSETUP_SET_SHOW_INACTIVE:
      return {
        ...state,
        showInactive: action.payload,
      };
    case types.USERSETUP_SET_FILTERED_DATA:
      let filtered =
        action.payload === true
          ? state.userSetup.Data
          : _.filter(state.userSetup.Data, x => x.IsActive === true);
      filtered = _.orderBy(filtered, [x => x.UserName.toLowerCase()]);
      return {
        ...state,
        filteredData: filtered,
      };
    case types.USERSETUP_POST:
      return {
        ...state,
        result: {
          ...state.result,
          errors: action.payload.data.Errors,
        },
      };
    case types.USERSETUP_BEGIN_SUBMIT:
      return {
        ...state,
        result: {
          ...state.result,
          errors: [],
          isSubmitting: true,
        },
      };
    case types.USERSETUP_END_SUBMIT:
      return {
        ...state,
        result: {
          ...state.result,
          isSubmitting: false,
        },
      };
    case types.USERSETUP_HAD_ERROR:
      return {
        ...state,
        result: {
          ...state.result,
          errors: action.payload,
          isSubmitting: false,
        },
      };
    case types.USERSETUP_UPDATE_IS_PAGE_ACCESSIBLE: {
      let checkAllChecked = false;
      const copiedStateData = _.cloneDeep(state.assignSiteData);
      const { currentRows, fieldName, id, index } = action.payload;
      const siteIndex = _.findIndex(copiedStateData, ['Id', id]);
      if (siteIndex > -1) {
        const userDetail = copiedStateData[siteIndex];
        userDetail[FieldEnum.AccessibleFunctions][index][
          fieldName
        ] = !currentRows[fieldName];
        copiedStateData[siteIndex] = userDetail;
      }
      checkAllChecked =
        copiedStateData.length !== 0 &&
        copiedStateData.length ===
          _.sumBy(copiedStateData, user => user[FieldEnum.Allowed]);
      return {
        ...state,
        assignSiteData: copiedStateData,
        checkAllChecked,
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/usersetup/state/reducer.js